import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Container = styled.div`
  display: flex;
  flex-direction: row;
`;

const Line = styled.div`
  margin-top: 6px;
  width: 30px;
  height: 0px;
  border: 1px solid ${props => props.theme.secondaryColorLight};
  display: inline-block;
`;

const Text = styled.label`
  margin: 0 6px;
  font-family: ${props => props.theme.fontFamilyBody};
  font-size: 13px;
  font-weight: ${props => props.theme.fontWeightHeavy};
  text-transform: uppercase;
`;

export default function Separator(props) {
  return (
    <Container>
      <Line />
      <Text>{props.text}</Text>
      <Line />
    </Container>
  );
}

Separator.propTypes = {
  text: PropTypes.string.isRequired,
};
